import type {
  CreateSaunaSetupNotePayload,
  DeleteSaunaSetupNotePayload,
  SaunaCommandResult,
  SaunaHistoryResponse,
  SaunaSessionHistoryResponse,
  UpdateSaunaConfigPayload,
  UpdateSaunaSetupNotePayload,
} from '@jums-dashboard/shared';

import { callFunction } from '@/lib/callableClient';

interface SaunaCommandPayload {
  homeId: string;
}

export function startSauna(homeId: string): Promise<SaunaCommandResult> {
  return callFunction<SaunaCommandPayload, SaunaCommandResult>('startSaunaCallable', { homeId });
}

export function finishSauna(homeId: string): Promise<SaunaCommandResult> {
  return callFunction<SaunaCommandPayload, SaunaCommandResult>('finishSaunaCallable', { homeId });
}

export function acknowledgeSaunaReady(homeId: string): Promise<SaunaCommandResult> {
  return callFunction<SaunaCommandPayload, SaunaCommandResult>('acknowledgeSaunaReadyCallable', { homeId });
}

export function abortSauna(homeId: string): Promise<SaunaCommandResult> {
  return callFunction<SaunaCommandPayload, SaunaCommandResult>('abortSaunaCallable', { homeId });
}

export function getSaunaHistory(homeId: string, days: number): Promise<SaunaHistoryResponse> {
  return callFunction<{ homeId: string; days: number }, SaunaHistoryResponse>('getSaunaHistoryCallable', { homeId, days });
}

export function updateSaunaConfig(payload: UpdateSaunaConfigPayload): Promise<{ ok: true }> {
  return callFunction<UpdateSaunaConfigPayload, { ok: true }>('updateSaunaConfigCallable', payload);
}

export function getSaunaSessionHistory(homeId: string): Promise<SaunaSessionHistoryResponse> {
  return callFunction<{ homeId: string }, SaunaSessionHistoryResponse>('getSaunaSessionHistoryCallable', { homeId });
}

export function createSaunaSetupNote(payload: CreateSaunaSetupNotePayload): Promise<{ noteId: string }> {
  return callFunction<CreateSaunaSetupNotePayload, { noteId: string }>('createSaunaSetupNoteCallable', payload);
}

export function updateSaunaSetupNote(payload: UpdateSaunaSetupNotePayload): Promise<{ ok: true }> {
  return callFunction<UpdateSaunaSetupNotePayload, { ok: true }>('updateSaunaSetupNoteCallable', payload);
}

export function deleteSaunaSetupNote(payload: DeleteSaunaSetupNotePayload): Promise<{ ok: true }> {
  return callFunction<DeleteSaunaSetupNotePayload, { ok: true }>('deleteSaunaSetupNoteCallable', payload);
}
